module.exports = __webpack_public_path__ + "img/sld_scb_22_t1_b1_green.3d83112b.svg";